import { useState } from "react";
import { Button, Form, Modal, Typography, Input, DatePicker, Alert, message, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useAuth } from "../../contexts/authContext";
import constants from "../../constants";
import axios from "axios";

const AddNewLead = ({ updateRow }) => {
  const { Option } = Select;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { getToken } = useAuth();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const saveLead = async (form) => {
    setLoading(true);
    try {
      const token = await getToken();
      const headers = {
        authorization: `bearer ${token}`,
      };
      const url = `${constants.NEW_DOMAIN}/api/v1/channelPartnerLeads/addLead`;
      const res = await axios.post(url, { ...form }, { headers });
      message.success("Data updated successfully");
      setLoading(false);
      setIsModalOpen(false);
      updateRow(res.data.data);
    } catch (error) {
      setLoading(false);
      setError(error.message || "something went wrong , try again later");
    }
  };

  return (
    <>
      <Typography.Title level={4} style={{ margin: "8px 0 16px" }}>
        Leads
        <Button type="link" onClick={showModal}>
          + Add new lead
        </Button>
      </Typography.Title>

      <Modal title="Add Lead" closable={{ "aria-label": "Custom Close Button" }} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        {error ? <Alert style={{ margin: "7px 0" }} message="Error" description={error} type="error" showIcon closable /> : null}
        <Form size="small" name="basic" style={{ maxWidth: 600 }} initialValues={{ remember: true }} onFinish={saveLead} autoComplete="off">
          <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please input your name!" }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Email" name="email" rules={[{ type: "email", required: true, message: "Please input valid email!" }]}>
            <Input />
          </Form.Item>

          <Form.Item label="Phone" name="phone" rules={[{ required: true, message: "Please input phone number!" }]}>
            <Input />
          </Form.Item>

          <Form.Item label="School" name="school" rules={[{ required: true, message: "Please input phone number!" }]}>
            <Input />
          </Form.Item>

          <Form.Item name="programCode" label="Program Code" rules={[{ required: true }]}>
            <Select placeholder="">
              <Option value="DUBAI">DUBAI</Option>
              <Option disabled value="ITALY">
                ITALY
              </Option>
            </Select>
          </Form.Item>

          <Form.Item name="followupDate" label="Follow-up On">
            <DatePicker placement="topLeft" format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item name="comments" label="Comments">
            <TextArea />
          </Form.Item>

          <Form.Item label={null}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Save
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default AddNewLead;
